import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useUser } from 'modules/User';
import { isStandalone } from 'utils/environment';
import CollaborationLoader from './CollaborationLoader';
import { useVenngageE1Gate } from 'hooks/useVenngageE1Gate';

type CollaborationProps = {
  children: React.ReactNode;
};

/**
 * Render the CollaborationLoader component if it passed this conditions:
 * 1) It is not a standalone mode
 * 2) It has a infographId
 * 3) It has a userData.user_id
 * 4) The 'enable_editor2_teamshare' feature flag is disabled
 * @param {CollaborationProps}
 * @returns {ReactElement}
 */
export const Collaboration: React.FC<CollaborationProps> = ({ children }) => {
  const { venngageE2 } = useVenngageE1Gate();
  const params = useParams();
  const { data: userData } = useUser();
  const { id: infographId } = params || {};

  const shouldSkipLoad = useMemo(
    () => isStandalone || !infographId || !userData?.user_id || !venngageE2?.experiments?.teamshare,
    [infographId, userData, venngageE2],
  );

  if (shouldSkipLoad) return <>{children}</>;

  return (
    <CollaborationLoader infographId={infographId!} userId={userData?.user_id!}>
      {children}
    </CollaborationLoader>
  );
};

export default Collaboration;
